import React from 'react';
import { RouteComponentProps } from 'react-router';

import { LevelGiftListContainer } from '../../epic/level-gift-list';

export const Page: React.FC<RouteComponentProps> = () => {
  return <LevelGiftListContainer />;
};
